import axios from 'axios'
import { getResponseErrorMessage } from '@/store/utils'
import { paginationState, paginationMutations } from '@/store/mixins/pagination'
import formsModule from './forms'

const state = {
  users: [],
  ...paginationState,
}

const getState = () => JSON.parse(JSON.stringify(state))

export default {
  namespaced: true,
  modules: {
    forms: formsModule,
  },
  state: getState(),
  getters: {},
  actions: {
    initialize ({ dispatch }) {
      return dispatch('fetchUsers', { page: 1, query: null })
    },
    setQuery ({ commit, dispatch }, query) {
      commit('SET_QUERY', query)
      return dispatch('fetchUsers')
    },
    fetchUsers ({ commit, state }) {
      commit('SET_IS_LOADING', true, { root: true })
      let url = `/admin/users?page=${state.page}&limit=${state.perPage}`
      if (state.query) {
        url += `&by_query=${encodeURIComponent(state.query)}`
      }

      return axios
        .get(url)
        .then((response) => {
          commit('SET_USERS', response.data)
          commit('SET_TOTAL_RESULTS', response.headers['total-count'])
          commit('SET_NUMBER_OF_PAGES', response.headers['total-pages'])
        })
        .catch(error => {
          console.error(error)
          const errorMessage = getResponseErrorMessage(error) ?? 'Napaka pri pridobivanju uporabnikov, prosimo poskusite kasneje.'
          commit('SET_MESSAGE', { text: errorMessage, type: 'error' }, { root: true })
        })
        .finally(() => commit('SET_IS_LOADING', false, { root: true }))
    },
    goToPage ({ commit, dispatch, state }, page) {
      if (page > 0 && page <= state.numberOfPages) {
        commit('SET_PAGE', page)
        return dispatch('fetchUsers')
      }
    },
    reset ({ commit }) {
      commit('RESET_STATE')
    },
  },
  mutations: {
    SET_USERS (state, users) {
      state.users = users
    },
    RESET_STATE (state) {
      Object.assign(state, getState())
    },
    ...paginationMutations,
  },
}
